import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Wand2, CheckCircle2 } from "lucide-react";
import { Stardust } from "@/components/Stardust";
import { http } from "@/lib/api";

export default function PaymentSuccess() {
  const nav = useNavigate();
  const [msg, setMsg] = useState("Confirming your payment…");

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) {
      setMsg("Missing payment reference.");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await http.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid" && data.download_token) {
          setMsg("Payment confirmed! Taking you to your download…");
          setTimeout(() => nav(`/download/${data.download_token}`), 900);
          return;
        }
        if (["expired", "failed"].includes(data.status)) {
          setMsg("Payment did not complete. Please try again.");
          return;
        }
      } catch (e) {
        /* keep polling */
      }
      if (attempts < 20) setTimeout(poll, 2000);
      else setMsg("Still processing. Check 'Find my order' in a moment.");
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nav]);

  return (
    <div className="relative grid min-h-screen place-items-center bg-parchment px-6">
      <Stardust count={30} />
      <div className="relative text-center" data-testid="payment-success">
        <div className="mx-auto grid h-24 w-24 place-items-center rounded-full bg-gradient-to-tr from-[#4A235A] to-[#9B5DE5]">
          <CheckCircle2 size={48} className="text-[#F4D03F]" />
        </div>
        <h1 className="mt-6 font-display text-3xl font-black text-[#1A0F1C]">Your legend is ready</h1>
        <p className="mt-3 flex items-center justify-center gap-2 text-base font-semibold text-[#5C4A61]">
          <Wand2 size={18} className="text-[#9B5DE5]" /> {msg}
        </p>
      </div>
    </div>
  );
}
